export default __webpack_public_path__ + "static/media/no.82db1dca.png";